require('./baseState.js');

PegasusTemplate.HoveringState = PegasusTemplate.BaseState.extend({
  setup: function(manager, context) {
    this._super( manager, context );
    PegasusTemplate.lookupController('blockOperations').set('content', context.view);
  },
  gotoIdle: function( manager, context ) {
    manager.transitionTo('idling', context);
  },
  hover: function(manager, context){
    manager.transitionTo('hovering', context);
  },
  viewOperations: function(manager, context){
    manager.transitionTo('viewingOperations', context);
  },
  gotoValidating: function(manager){
    manager.transitionTo('validating.confirming');
  },
  gotoTesting: function(manager){
    manager.transitionTo('validating.testing');
  },
  changePalette: function(manager, view){
    manager.transitionTo('editing.palette', view);
  }
});
